import React, { useContext, useEffect, useState } from 'react'
import './MarketResult.css'
import CurrentDayTime from '../14-currentDate/CurrentDayTime'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { format } from 'date-fns'
import { LoaderContext } from '../15-loader/LoaderProvider'




const MarketResult = () => {

    const navigate = useNavigate()
    const { setIsLoading } = useContext(LoaderContext);

    const [marketApiData, setMarketApiData] = useState([]);

    const getMarket = async () => {
        await axios.get(`${process.env.REACT_APP_BASE_URL}/web/getMarkets`)
            .then((r) => {
                setMarketApiData(r.data.data)
                setIsLoading(false)
            })
            .catch((err) => console.log(err.message));
    }

    useEffect(() => {
        getMarket()
    }, []);

    function sumGetLastDigit(value) {

        if (value == null) {
            return null;
        } else {
            return (
                value
                    .toString()
                    .split('')
                    .map(Number)
                    .reduce(function (a, b) {
                        return a + b;
                    }, 0) % 10
            );
        }
    }

    const date = new Date();
    const dateForOpen = (time) => new Date(`${new Date().toDateString()} ${time}`)


    return (
        <div className='market-result'>

            <div className='market-result-content'>

                <div className='container'>

                    <div className='market-result-heading' ><h2>AVAILABLE GAMES</h2></div>


                    <div className='market-result-boxes'>

                        {
                            marketApiData.map((data, index) => {

                                return (

                                    <div className='result-box' key={data.id} >

                                        <div className='heading'>

                                            <div className='open-time'><h6>Last Open Bid</h6><h6>{data.OpenTime ? data.OpenTime : '-'} </h6></div>
                                            <div className='market-name'><h3>{data.Market ? data.Market : '-'}</h3></div>
                                            <div className='close-time'><h6>Last Close Bid</h6><h6>{data.CloseTime ? data.CloseTime : '-'} </h6></div>

                                        </div>

                                        <div className='star-result' >

                                            <h2 className={`${data?.OpenResult ? 'star-blink' : date > dateForOpen(data.OpenTime) && date < dateForOpen(data.CloseTime) ? 'star-slide' : ''}`}>

                                                {data.OpenResult ? data.OpenResult : <div className='star'>***</div>}
                                                <span className='dash'><hr /></span>
                                                {data?.OpenResult ? sumGetLastDigit(data?.OpenResult) : <div className='star'>*</div>}
                                                {data?.CloseResult ? sumGetLastDigit(data?.CloseResult) : <div className='star'>*</div>}
                                                <span className='dash'><hr /></span>
                                                {data.CloseResult ? data.CloseResult : <div className='star'>***</div>}

                                            </h2>

                                        </div>

                                        <div className='button row'>

                                            <div className='col jodi-chart btn' onClick={() => navigate(`/market-result/jodichart/${data.MarketId}`)}>JODI CHART</div>
                                            <div className='col pana-chart btn' onClick={() => navigate(`/market-result/panachart/${data.MarketId}`)}>PANA CHART</div>

                                        </div>

                                    </div>
                                )

                            })
                        }

                    </div>

                </div>

            </div>

        </div>
    )
}

export default MarketResult
